import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaEnquiryTypes } from './sagaEnquiryRedux';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import { push } from 'react-router-redux';
import { buildUrl, getCurrentUserId } from '../../helpers/utility';
import { Result } from 'redux/helpers/Ihelper';
import { EnquiryInfomation } from './IEnquiryDetail';

export function* requestGetMyEnquiries(action) {
    const tag = '[REQUEST_GET_MY_ENQUIRIES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetMyEnquiries, jwtToken, action.userId, culture, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetMyEnquiries response :`, response.data);
                yield put(Actions.getMyEnquiriesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetMyEnquiries failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getMyEnquiriesFailure(message));
    }
}

export function* requestUpdateEnquirySource(action) {
    const tag = '[REQUEST_UPDATE_ENQUIRY_SOURCE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.UpdateEnquirySource, jwtToken, action.enquiryId, action.source);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateEnquirySource response :`, response.data);
                yield put(Actions.requestGetMyEnquiries(action.userId, action.propertyId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateEnquirySource failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateEnquirySourceFailure(message));
    }
}

export function* requestUpdateEnquiryStatus(action) {
    const tag = '[REQUEST_UPDATE_ENQUIRY_STATUS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.UpdateEnquiryStatus, jwtToken, action.enquiryId, action.status);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateEnquiryStatus response :`, response.data);
                yield put(Actions.requestGetMyEnquiries(action.userId, action.propertyId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateEnquiryStatus failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateEnquiryStatusFailure(message));
    }
}


export function* requestCreateEnquiryMemo(action) {
    const tag = '[REQUEST_CREATE_ENQUIRY_MEMO]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.CreateEnquiryMemo, jwtToken, action.enquiryId, action.status, action.memo, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestCreateEnquiryMemo response :`, response.data);
                yield put(Actions.requestGetMyEnquiries(action.userId, action.propertyId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateEnquiryMemo failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createEnquiryMemoFailure(message));
    }
}

export function* requestGetEnquiry(action) {
    const tag = '[REQUEST_GET_ENQUIRY]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetEnquiry, jwtToken, branchId, culture, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEnquiry response :`, response.data);
                yield put(Actions.getEnquirySuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEnquiry failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEnquiryFailure(message));
    }
}

export function* requestUpdateEnquiryBatch(action) {
    const tag = '[REQUEST_UPDATE_ENQUIRY_BATCH]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateEnquiryBatch, jwtToken, branchId, culture, action.updateEnquiryBatch);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateEnquiryBatch response :`, response.data);
                yield put(Actions.updateEnquiryBatchSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateEnquiryBatch failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateEnquiryBatchFailure(message));
    }
}



export function* requestExportEnquiryReport(action) {
    const tag = '[REQUESTEXPORT_ENQUIRY_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestExportEnquiryReport, jwtToken, branchId, culture, action.enquiryReportInput);
            if (response.status === 200 && response.data.statusCode === 200) {
                window.open(response.data.result, '_blank');
                console.log(`${tag} requestexportEnquiryReport response :`, response.data);
                yield put(Actions.exportEnquiryReportSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestExportEnquiryReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.exportEnquiryReportFailure(message));
    }
}
export function* requestGetEnquiryDetail(action) {
    const tag = '[REQUEST_GET_ENQUIRY_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetEnquiryDetail, jwtToken, branchId, culture, action.enquiryId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEnquiryDetail response :`, response.data);
                yield put(Actions.getEnquiryDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEnquiryDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEnquiryDetailFailure(message));
    }
}

export function* requestUpdateEnquiryDetail(action) {
    const tag = '[REQUEST_UPDATE_ENQUIRY_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        const result = validateRequestCreateEnquiryDetail(action.enquiryInfomation);
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            if (result.isValid) {
                const response = yield call(API.requestUpdateEnquiryDetail, jwtToken, action.enquiryInfomation);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestUpdateEnquiryDetail response :`, response.data);
                    yield put(Actions.updateEnquiryDetailSuccess(response.data.result));
                    yield put(push(buildUrl(`/dashboard/account/enquiry/${response.data.result}`)));
                } else {
                    throw new Error(response.data.error);
                }
            } else {
                yield put(Actions.updateEnquiryDetailFailure(result.errorMessages));
            }
        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateEnquiryDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateEnquiryDetailFailure(message));
    }
}

function validateRequestCreateEnquiryDetail(enquiryInfomation: EnquiryInfomation) {
    const result: Result = {
        isValid: false,
        errorMessages: []
    };
    if (!enquiryInfomation) {
        result.isValid = true;
        return result;
    }
    let isValid = false;
    const errorMessage: string[] = [];

    // Sale Or Rent 
    if (enquiryInfomation.enquiryIsSale !== null) {
        isValid = true;
    }
    // Type
    if (enquiryInfomation.enquiryType) {
        isValid = true;
    }
    // Property Type
    if (enquiryInfomation.enquiryPropertyType) {
        isValid = true;
    }
    // size start
    if (enquiryInfomation.enquirySizeStart) {
        isValid = true;
    }
    // size end
    if (enquiryInfomation.enquirySizeEnd) {
        isValid = true;
    }
    // land start 
    if (enquiryInfomation.enquiryLandsizeStart) {
        isValid = true;
    }
    // land end
    if (enquiryInfomation.enquiryLandsizeEnd) {
        isValid = true;
    }
    // price start
    if (enquiryInfomation.enquiryPriceStart || (enquiryInfomation.enquiryPriceStart === 0 && enquiryInfomation.enquiryPriceEnd === 0)) {
        isValid = true;
    }
    // price end
    if (enquiryInfomation.enquiryPriceEnd || (enquiryInfomation.enquiryPriceStart === 0 && enquiryInfomation.enquiryPriceEnd === 0)) {
        isValid = true;
    }

    if (!isValid) {
        errorMessage.push('enquiry.enquiryDetail.mustSelectlease1Field');
    }

    result.isValid = isValid;
    result.errorMessages = errorMessage;
    return result;
}

export function* requestFindMatchProperty(action) {
    const tag = '[REQUEST_FIND_MATCH_PROPERTY]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            const response = yield call(API.requestFindMatchProperty, jwtToken, branchId, culture, action.enquiryId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestFindMatchProperty response :`, response.data);
                yield put(Actions.findMatchPropertySuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestFindMatchProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.findMatchPropertyFailure(message));
    }
}

export function* requestDeleteEnquiry(action) {
    const tag = '[REQUEST_DELETE_ENQUIRY]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestDeleteEnquiry, jwtToken, action.enquiryId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteEnquiry response :`, response.data);
                if (response.data.result) {
                    yield put(Actions.deleteEnquirySuccess(response.data.result));
                    yield put(push(buildUrl(`/dashboard/account/enquiry`)));
                }
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteEnquiry failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteEnquiryFailure(message));
    }
}
export function* requestDeleteEnquiries(action) {
    const tag = '[REQUEST_DELETE_ENQUIRIES]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const userId = yield getCurrentUserId();
        if (jwtToken) {
            const response = yield call(API.requestDeleteEnquiries, jwtToken, branchId, userId, culture, action.enquiryIds);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteEnquiries response :`, response.data);
                yield put(Actions.deleteEnquiriesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteEnquiries failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteEnquiriesFailure(message));
    }
}


export default function* rootSaga() {
    yield all([
        takeLatest(SagaEnquiryTypes.REQUEST_GET_MY_ENQUIRIES, requestGetMyEnquiries),
        takeLatest(SagaEnquiryTypes.REQUEST_UPDATE_ENQUIRY_SOURCE, requestUpdateEnquirySource),
        takeLatest(SagaEnquiryTypes.REQUEST_UPDATE_ENQUIRY_STATUS, requestUpdateEnquiryStatus),
        takeLatest(SagaEnquiryTypes.REQUEST_CREATE_ENQUIRY_MEMO, requestCreateEnquiryMemo),
        takeLatest(SagaEnquiryTypes.REQUEST_GET_ENQUIRY, requestGetEnquiry),
        takeLatest(SagaEnquiryTypes.REQUEST_UPDATE_ENQUIRY_BATCH, requestUpdateEnquiryBatch),
        takeLatest(SagaEnquiryTypes.REQUEST_EXPORT_ENQUIRY_REPORT, requestExportEnquiryReport),
        takeLatest(SagaEnquiryTypes.REQUEST_GET_ENQUIRY_DETAIL, requestGetEnquiryDetail),
        takeLatest(SagaEnquiryTypes.REQUEST_UPDATE_ENQUIRY_DETAIL, requestUpdateEnquiryDetail),
        takeLatest(SagaEnquiryTypes.REQUEST_FIND_MATCH_PROPERTY, requestFindMatchProperty),
        takeLatest(SagaEnquiryTypes.REQUEST_DELETE_ENQUIRY, requestDeleteEnquiry),
        takeLatest(SagaEnquiryTypes.REQUEST_DELETE_ENQUIRIES, requestDeleteEnquiries),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaEnquiry/sagaEnquirySaga.ts